import { render, staticRenderFns } from "./_DashboardSidebar.vue?vue&type=template&id=42975fbc&scoped=true"
import script from "./_DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./_DashboardSidebar.vue?vue&type=script&lang=js"
import style0 from "./_DashboardSidebar.vue?vue&type=style&index=0&id=42975fbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42975fbc",
  null
  
)

export default component.exports